"use strict";
/**
 * Logger
 */
Object.defineProperty(exports, "__esModule", { value: true });
class Logger {
    constructor(logMethod) {
        this.method = logMethod;
    }
    log(...args) {
        args.forEach(this.method);
    }
}
exports.Logger = Logger;



// WEBPACK FOOTER //
// ./src/index.ts